export function translateOrderState(orderState: string): string {
  console.log("orderState", orderState);
  switch (orderState) {
    case "REGISTER":
      return "운송등록";
    case "TEMP":
      return "임시저장";
    case "CONFIRM":
      return "운송확정";
    case "RETURN":
      return "운송반려";
    case "DISPATCH":
      return "배차완료";
    case "COMPLETED":
      return "운송완료";
    // 운송완료 검토중
    case "COMPLETED_REVIEW":
      return "운송완료 검토중";
    case "TAX_INVOICE_REQUEST_COMPLETED":
      return "세금계산서 요청완료";
    case "TAX_INVOICE_ERROR":
      return "세금계산서 오류";
    case "TAX_INVOICE_PUBLISHED_COMPLETED":
      return "세금계산서 발행완료";
    default:
      return "알 수 없음";
  }
}

export function translateImportExport(importExport: number): string {
  return importExport === 1 ? "수입" : "수출";
}

export function translatePaymentState(paymentState: number): string {
  switch (paymentState) {
    case 1:
      return "계좌이체";
    case 2:
      return "카드결제";
    default:
      return "알 수 없음";
  }
}
